module.exports = __webpack_public_path__ + "static/media/arrow.ecaebf72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Svg/arrow.svg
// module id = 251
// module chunks = 0